import { HotelFareDetailParams } from './const';

export const parseFareDetailParams = (data: URLSearchParams) => {
  const hotelId = data.get(HotelFareDetailParams.hotelId) || '';
  const hash = data.get(HotelFareDetailParams.hash) || '';

  return {
    hotelId,
    hash 
  };
};

export const appendFaresQueryParamsToUrl = (hotelId: number, hash: string): URLSearchParams | null => {
  const queryParams = new URLSearchParams();

  if (hotelId && hash) {
    queryParams.append(
      HotelFareDetailParams.hotelId, 
      String(hotelId)
    );
    queryParams.append(
      HotelFareDetailParams.hash, 
      String(hash)
    );

    return queryParams;
  }

  return null;
};
